import React from 'react';
import './BetaPill.css';

export default function BetaPill({ className = '' }) {
  return (
    <div className={`beta-pill ${className}`} aria-hidden>
      BETA
    </div>
  );
}
